import React from 'react';
import { ArrowRight } from 'core/icons';
import { StyledItem, StyledLink } from './styled';

class BreadcrumbItem extends React.PureComponent {
  state = {
    truncate: undefined,
  };

  componentDidMount() {
    const { truncationWidth } = this.props;
    if (truncationWidth) {
      const { width } = this._item.getBoundingClientRect();
      this.setState(prevState => Object.assign({}, prevState, {
        truncate: (width / truncationWidth) > 1.2,
      }));
    } else {
      this.setState(prevState => Object.assign({}, prevState, {
        truncate: false,
      }));
    }
  }

  render() {
    const {
      path,
      title,
      hasChild,
      truncationWidth,
    } = this.props;

    const visibleAfterMeasure = this.state.truncate === undefined ? 'hidden' : 'visible';

    return (
      <StyledItem
        innerRef={c => this._item = c}
        style={{ visibility: visibleAfterMeasure }}
      >
        <StyledLink
          to={path}
          title={title}
          truncate={this.state.truncate ? truncationWidth : undefined}
        >
          {title}
        </StyledLink>

        {
          hasChild && (
            <ArrowRight size='small' />
          )
        }
      </StyledItem>
    );
  }
}

export default BreadcrumbItem;



// WEBPACK FOOTER //
// ./src/elements/Breadcrumbs/components/BreadcrumbItem/BreadcrumbItem.jsx